/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetFeedbackResponseArray } from '../../models/get-feedback-response-array';

export interface GetFeedbacks$Params {
}

export function getFeedbacks(http: HttpClient, rootUrl: string, params?: GetFeedbacks$Params, context?: HttpContext): Observable<StrictHttpResponse<GetFeedbackResponseArray>> {
  const rb = new RequestBuilder(rootUrl, getFeedbacks.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetFeedbackResponseArray>;
    })
  );
}

getFeedbacks.PATH = '/service-provider/feedbacks';
